import type { EmblaCarouselType } from 'embla-carousel';
// ⚠️ 값이 아니라 **타입만** 들여온다 — 이 한 줄이 `embla-carousel` 쪽 선언 병합
//    (`EmblaPluginsType.autoplay` · `autoplay:play`/`autoplay:stop` 이벤트)을 함께 끌어온다.
import type { AutoplayType } from 'embla-carousel-autoplay';

import { useState, useEffect, useCallback } from 'react';

// ----------------------------------------------------------------------

export function useCarouselAutoPlay(mainApi?: EmblaCarouselType) {
  const [isPlaying, setIsPlaying] = useState(false);

  const onClickAutoplay = useCallback(
    (callback: () => void) => {
      const autoplay = mainApi?.plugins()?.autoplay as AutoplayType | undefined;
      if (!autoplay) return;

      const resetOrStop =
        autoplay.options.stopOnInteraction === false ? autoplay.reset : autoplay.stop;

      resetOrStop();
      callback();
    },
    [mainApi]
  );

  const onTogglePlay = useCallback(() => {
    const autoplay = mainApi?.plugins()?.autoplay as AutoplayType | undefined;
    if (!autoplay) return;

    const playOrStop = autoplay.isPlaying() ? autoplay.stop : autoplay.play;
    playOrStop();
  }, [mainApi]);

  useEffect(() => {
    const autoplay = mainApi?.plugins()?.autoplay as AutoplayType | undefined;
    if (!autoplay) return;

    setIsPlaying(autoplay.isPlaying());
    // `autoplay` 가 있으면 `mainApi` 도 있다 — 좁히기가 옵셔널 체인을 넘어오지 못해 `!` 로만 알린다
    mainApi!
      .on('autoplay:play', () => setIsPlaying(true))
      .on('autoplay:stop', () => setIsPlaying(false))
      .on('reInit', () => setIsPlaying(false));
  }, [mainApi]);

  return { isPlaying, onTogglePlay, onClickAutoplay };
}
